import routineReducerFactory from "./routineReducerFactory";
import {fetchRecipeCategories} from "../actions/routines";

const recipeCategories = routineReducerFactory(fetchRecipeCategories, {data: []});

export default recipeCategories;